import AdminPanel from "./components/Adminpanel";


function App() {
  return (
    <div><AdminPanel/></div>
  );
}

export default App;
